import {DimensionsInPx} from '@domain/dimensions-in-px';
import {OverviewMachine} from '@presentation/pages/machine-overview/overview-machine';

export class Floorplan {
  private _machines: OverviewMachine[];
  private _dimensionsInPx: DimensionsInPx;

  public constructor(dimensionsInPx: DimensionsInPx, machines: OverviewMachine[]) {
    this._dimensionsInPx = dimensionsInPx;
    this._machines = machines;
  }

  public get dimensionsInPx(): DimensionsInPx {
    return this._dimensionsInPx;
  }

  public set dimensionsInPx(dimensionsInPx: DimensionsInPx) {
    this._dimensionsInPx = dimensionsInPx;
  }

  public get machines(): OverviewMachine[] {
    return this._machines;
  }

  public set machines(machines: OverviewMachine[]) {
    this._machines = machines;
  }

  public addMachine(machine: OverviewMachine): void {
    this._machines.push(machine);
  }
}
